import { MonitorSmartphone, Palette, Clock, ShieldCheck } from 'lucide-react';
import CategoryTemplate from '../components/CategoryTemplate';
import { getRelated } from '../data/serviceCatalog';

const ElectricBoard = () => {
  const trustPoints = [
    { Icon: Palette, label: 'フルカラー / 単色 選択' },
    { Icon: MonitorSmartphone, label: 'リアルタイム更新' },
    { Icon: Clock, label: '長時間運用に対応' },
    { Icon: ShieldCheck, label: '屋内・屋外 対応' },
  ];

  const types = [
    { title: 'フルカラーLED電光掲示板', desc: '文字・図形・動画を鮮やかに表示。案内・広告・演出向け。' },
    { title: '単色LED電光掲示板', desc: '案内・注意喚起・数値表示など、視認性を重視した用途向け。' },
    { title: 'セグメント式表示板', desc: '数字や記号を大きく確実に表示。カウンター・料金・案内表示に。' },
    { title: 'ドットマトリクス式表示板', desc: '文字・記号の組み合わせで幅広い表示に対応。' },
    { title: 'パタパタ切替式表示板', desc: '状態の切替表示に。空満表示や運用状況の切替向け。' },
    { title: 'スクロール式表示板', desc: '長文の案内や情報を横方向にスクロール表示。' },
  ];

  const process = [
    { title: 'ヒアリング', desc: '表示内容・設置場所・視認距離・運用方法をお伺いします。' },
    { title: '現地調査・仕様検討', desc: '取付面・電源・視認角度・耐候要件を確認し、仕様をご提案します。' },
    { title: 'デザイン・見積提出', desc: '表示レイアウトと見積りをご提出し、内容の合意を得ます。' },
    { title: '製作・現場施工', desc: '製作と現場での取付施工まで一貫して対応します。' },
  ];

  return (
    <CategoryTemplate
      id="electric-board"
      eyebrow="ELECTRIC BOARD"
      name="電光掲示板"
      description="案内・誘導・注意喚起など、目的に合わせた電光掲示板をご提案いたします。駐車場や施設、工場、公共スペースなど、表示内容や設置環境に合わせて対応いたします。"
      tags={['屋内対応', '屋外対応', 'フルカラー / 単色', 'リアルタイム更新', 'カスタムサイズ']}
      heroImage="/images/services/electric-board.png"
      trustPoints={trustPoints}
      types={types}
      processSteps={process}
      relatedServices={getRelated(['led-vision', 'signage', 'parking-system'])}
    />
  );
};

export default ElectricBoard;
